export default "__VITE_ASSET__xUi6oKac__"